import styled from '@xstyled/styled-components';

export const LeftShape = styled.div`
  position: absolute;
  top: 2px;
  left: 2px;
  right: 2px;
  bottom: 2px;
  z-index: 2;
  background-color: white;
  border-top-left-radius: xl;
  border-bottom-left-radius: xl;
  height: 100px;
  width: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;

  &:after {
    content: '';
    position: absolute;
    right: -30px;
    bottom: 0;
    width: 0;
    height: 0;
    border-left: 30px solid white;
    border-top: 50px solid transparent;
    border-bottom: 50px solid transparent;
  }
`;
